import { onMounted as r, onBeforeUnmount as u, openBlock as o, createBlock as m, Transition as f, withCtx as y, createElementVNode as i, withDirectives as p, createElementBlock as a, normalizeClass as b, createVNode as h, createCommentVNode as k, renderSlot as C, unref as B } from "vue";
import v from "../icon-core/icon-core.vue.js";
import g from "../../utils/directives/click-outside.js";
/* empty css           */
const w = { class: "ds-modal ds-modal--backdrop" }, O = {
  role: "dialog",
  "aria-modal": "true",
  class: "ds-container ds-height-full ds-display-flex ds-align-items-center ds-justify-content-center",
  "data-j-modal": ""
}, _ = ["aria-label"], E = "inside", d = "outside", D = /* @__PURE__ */ Object.assign({
  name: "DsModal"
}, {
  __name: "modal",
  props: {
    /**
     * Aria-label for the 'close' button
     */
    ariaLabelClose: { type: String, required: !0 },
    /**
     * Shows/hides the 'x' close icon. Displays it by default.
     */
    withCloseButton: { type: Boolean, default: !0 },
    /**
     * Closes the modal if the user clicks outside of the content box. Enabled by default. Set this prop to false if you want to force the user to click on the 'x' icon to close the modal.
     */
    closeOnClickOutside: { type: Boolean, default: !0 },
    /**
     * Position of close button
     * Possible values: 'inside', 'outside'. Defaults to 'outside'
     */
    closeButtonPosition: { type: String, default: d, validator: (e) => [E, d].includes(e) }
  },
  emits: ["close-modal"],
  setup(e, { emit: c }) {
    const s = c, n = () => {
      s("close-modal");
    }, l = (t) => {
      t.keyCode === 27 && s("close-modal");
    };
    return r(() => {
      document.addEventListener("keydown", l);
    }), u(() => {
      document.removeEventListener("keydown", l);
    }), (t, j) => (o(), m(f, {
      appear: "",
      name: "modal"
    }, {
      default: y(() => [
        i("div", w, [
          i("div", O, [
            p((o(), a("div", {
              class: b(["ds-display-flex ds-justify-content-center ds-width-full", { "ds-position-relative": e.closeButtonPosition === "inside" }])
            }, [
              e.withCloseButton ? (o(), a("button", {
                key: 0,
                type: "button",
                tabindex: "0",
                "aria-label": e.ariaLabelClose,
                class: "ds-modal__icon ds-button-circle-icon ds-button-circle-icon--light",
                "data-j-button": "",
                onClick: n
              }, [
                h(v, {
                  category: "interface",
                  name: "cross"
                })
              ], 8, _)) : k("", !0),
              C(t.$slots, "default")
            ], 2)), [
              [B(g), e.closeOnClickOutside ? n : null]
            ])
          ])
        ])
      ]),
      _: 3
    }));
  }
}), N = D;
export {
  N as default
};
